import { vars } from '@/app/config/variables';
import { Swiper } from 'swiper';
import { Keyboard, Navigation, Thumbs, Zoom } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/zoom';

export class ModalGalleryMain {
	private element: HTMLElement;
	private modalElement: HTMLElement | null;
	private readonly thumbs: Swiper;
	private readonly modalSelector = '.modal-gallery';
	private readonly sliderSelector = '.modal-gallery-main__slider';
	private readonly buttonPrevSelector = '.modal-gallery-main__button--prev';
	private readonly buttonNextSelector = '.modal-gallery-main__button--next';
	private sliderElement: HTMLElement;
	private buttonPrev: HTMLButtonElement;
	private buttonNext: HTMLButtonElement;
	private sliderSettings = (): SwiperOptions =>
		({
			modules: [Keyboard, Navigation, Thumbs, Zoom],
			slidesPerView: 1,
			rewind: true,
			keyboard: {
				enabled: false,
				onlyInViewport: true,
			},
			zoom: {
				maxRatio: 2,
				toggle: false,
			},
			navigation: {
				prevEl: this.buttonPrev,
				nextEl: this.buttonNext,
			},
			thumbs: {
				swiper: this.thumbs,
			},
			breakpoints: {
				[vars.breakpoint.tablet]: {
					zoom: {
						maxRatio: 3,
					},
				},
			},
		}) as SwiperOptions;

	public slider: Swiper;

	constructor(element: HTMLElement, thumbs: Swiper) {
		if (!element || !thumbs) return;

		this.element = element;
		this.thumbs = thumbs;
		this.init();
	}

	public init = (): void => {
		this.modalElement = this.element.closest(this.modalSelector);
		this.sliderElement = this.element.querySelector(this.sliderSelector);
		this.buttonPrev = this.element.querySelector(this.buttonPrevSelector);
		this.buttonNext = this.element.querySelector(this.buttonNextSelector);

		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		this.slider.on('click', this.handleZoomClick);
		this.modalElement?.addEventListener('modalOpen', this.handleModalOpen);
		this.modalElement?.addEventListener('modalClose', this.handleModalClose);
	};

	private handleModalOpen = (): void => {
		this.enableSliderControls();
	};

	private handleModalClose = (): void => {
		this.slider.keyboard.disable();
		this.slider.zoom.out();
		this.slider.zoom.disable();
		this.pauseVideos();
	};

	private handleZoomClick = (swiper: Swiper, event: Event): void => {
		if (!(event.target as HTMLElement).closest('.swiper-slide-active .swiper-zoom-container')) return;

		swiper.zoom.toggle();
	};

	private enableSliderControls = (): void => {
		this.slider.keyboard.enable();
		this.slider.zoom.enable();
	};

	private pauseVideos = (): void => {
		this.slider.slides.forEach(($slide) => {
			$slide.querySelector('video')?.pause();
		});
	};

	public destroy = (): void => {
		this.slider?.off('click', this.handleZoomClick);
		this.modalElement?.removeEventListener('modalOpen', this.handleModalOpen);
		this.modalElement?.removeEventListener('modalClose', this.handleModalClose);
		this.slider?.destroy(true, true);
	};
}
